export class ApsStaffPortalModel {
  GetArticleList: string = "";
  AuthenticateAPI: string = "";
  LoginID: string = "";
  Password: string = "";
}
